import { buildAddressPairLocationsInputSchema } from '../address/create-pair-input.js';
/** New Customer's address pair: the customer's own name is the address name, so it isn't sent again. */
export const createCustomerAddressPairInputSchema = buildAddressPairLocationsInputSchema({
    requireFullAddress: true,
});
//# sourceMappingURL=create-address-pair-input.js.map